import { IconAlertTriangle } from "@tabler/icons-react";

function InlineError({ children, className = "label-error-inline" }) {
  if (!children) return null;

  return (
    <span className={className}>
      <IconAlertTriangle size={14} stroke={2.2} />
      <span>{children}</span>
    </span>
  );
}

export default InlineError;
